import { TableCell, TableRow } from "@/components/ui/table";

/** Fixed-height placeholder rows so the table doesn't jump when data arrives. */
export function SkeletonRows({ columns, rows = 8 }: { columns: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <TableRow key={i} className="h-11 hover:bg-transparent">
          <TableCell colSpan={columns}>
            <div className="h-3.5 animate-pulse rounded bg-muted motion-reduce:animate-none" style={{ width: `${55 + ((i * 17) % 40)}%` }} />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}

export function EmptyRow({ columns, children }: { columns: number; children: React.ReactNode }) {
  return (
    <TableRow className="hover:bg-transparent">
      <TableCell colSpan={columns} className="h-32 text-center whitespace-normal text-muted-foreground">{children}</TableCell>
    </TableRow>
  );
}
